// Include all the standard Rails stuff, Bullet Train stuff, and application-level stuff.
require("../application")

// Include the stylesheets specific to this theme.
require("../stylesheets/light/application.scss")
